export const loadStyle = (
  name: string,
  staticURL: string,
  cssUrl: string,
  fromCDN?: boolean,
) => {
  const url = fromCDN ? cssUrl : `${staticURL}/${cssUrl}`;

  const element = document.createElement('link');

  element.href = url;
  element.rel = 'stylesheet';
  element.type = 'text/css';

  const deadline = 100000;
  let timerId: NodeJS.Timeout;
  const freeMemory = () => {
    element.onerror = null;
    element.onload = null;
    clearTimeout(timerId);
  };

  const onLoad = () => {
    freeMemory();
  };

  const onError = () => {
    freeMemory();
    console.error(`Failed load resource: ${element.href}`);
  };
  timerId = setTimeout(() => {
    freeMemory();
    console.error(
      `Failed load resource: ${element.href}. Exceeded time limit: ${deadline}`,
    );
  }, deadline);
  element.onload = onLoad;
  element.onerror = onError;

  if (document.head) {
    document.head.appendChild(element);
  }
};
